import { useRef, useEffect } from 'react';

export default function SceneLighting({ config }) {
  const ambientRef = useRef();
  const directionalRef = useRef();
  const pointRef = useRef();

  const { ambient, directional, point } = config || {};

  // Update lights when config changes
  useEffect(() => {
    if (ambientRef.current) {
      ambientRef.current.color.set(ambient?.color || '#ffffff');
      ambientRef.current.intensity = ambient?.intensity ?? 0.6;
    }
  }, [ambient?.color, ambient?.intensity]);

  useEffect(() => {
    if (directionalRef.current) {
      directionalRef.current.color.set(directional?.color || '#ffffff');
      directionalRef.current.intensity = directional?.intensity ?? 1.2;
      const pos = directional?.position || { x: 5, y: 10, z: 7 };
      directionalRef.current.position.set(pos.x, pos.y, pos.z);
    }
  }, [directional?.color, directional?.intensity, directional?.position]);

  useEffect(() => {
    if (pointRef.current) {
      pointRef.current.color.set(point?.color || '#ffaa77');
      pointRef.current.intensity = point?.intensity ?? 0.8;
      const pos = point?.position || { x: -3, y: 4, z: 3 };
      pointRef.current.position.set(pos.x, pos.y, pos.z);
    }
  }, [point?.color, point?.intensity, point?.position]);

  return (
    <>
      {ambient?.enabled !== false && (
        <ambientLight
          ref={ambientRef}
          color={ambient?.color || '#ffffff'}
          intensity={ambient?.intensity ?? 0.6}
        />
      )}
      {directional?.enabled !== false && (
        <directionalLight
          ref={directionalRef}
          color={directional?.color || '#ffffff'}
          intensity={directional?.intensity ?? 1.2}
          position={[
            directional?.position?.x ?? 5,
            directional?.position?.y ?? 10,
            directional?.position?.z ?? 7,
          ]}
          castShadow
        />
      )}
      {point?.enabled && (
        <pointLight
          ref={pointRef}
          color={point?.color || '#ffaa77'}
          intensity={point?.intensity ?? 0.8}
          position={[
            point?.position?.x ?? -3,
            point?.position?.y ?? 4,
            point?.position?.z ?? 3,
          ]}
          distance={20}
          decay={2}
        />
      )}
    </>
  );
}
